import { Model } from 'caldera-immutable-model';

import type { TabKey } from './types';
import typeof { APP_LIFECYCLE_STATE } from './constants';

export default class AppState extends Model {

  get error(): Error {
    return this.get('error');
  }

  setError(error: Error): AppState {
    return this.set('error', error);
  }

  get activeTab(): TabKey {
    return this.get('activeTab');
  }

  setActiveTab(activeTab: TabKey): AppState {
    return this.set('activeTab', activeTab);
  }

  get isInitialDataLoaded(): boolean {
    return !!this.get('isInitialDataLoaded');
  }

  setInitialDataLoaded(loaded: boolean): AppState {
    return this.set('isInitialDataLoaded', loaded);
  }

  get appLifecycleState(): $Keys<APP_LIFECYCLE_STATE> {
    return this.get('appLifecycleState');
  }

  setAppLifecycleState(appState: $Keys<APP_LIFECYCLE_STATE>): AppState {
    return this.set('appLifecycleState', appState);
  }
}



// WEBPACK FOOTER //
// ./src/redux/app/AppState.js